import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ld" }
const _hoisted_2 = { class: "lock-designer-layout" }
const _hoisted_3 = { class: "lock-designer-image-wrap" }

export function render(_ctx, _cache) {
  const _component_CustomZoomViewer = _resolveComponent("CustomZoomViewer")
  const _component_LoadIndicator = _resolveComponent("LoadIndicator")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "image-container",
        style: _normalizeStyle(`background-color: ${_ctx.dominantColor}`)
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_CustomZoomViewer, {
            class: "lock-designer-image",
            imageSrc: _ctx.imageUrl
          }, null, 8 /* PROPS */, ["imageSrc"])
        ])
      ], 4 /* STYLE */),
      _renderSlot(_ctx.$slots, "routerWrap"),
      _createVNode(_component_LoadIndicator, {
        loadingResults: _ctx.$store?.state?.isLoading,
        useTransition: true
      }, null, 8 /* PROPS */, ["loadingResults"])
    ])
  ]))
}